module.exports = __webpack_public_path__ + "img/Trash-icon.ebe10637.svg";